export const SET_SOCIETE_ACTIVE_ID = 'SET_SOCIETE_ACTIVE_ID';
export const SET_SOCIETE_ACTIVE = 'SET_SOCIETE_ACTIVE';
export const SET_AGENCE_ACTIVE = 'SET_AGENCE_ACTIVE';
export const SET_SOCIETE_OF_USER = 'SET_SOCIETE_OF_USER';
export const SET_DETECT_CHANGE_SOCIETE = 'SET_DETECT_CHANGE_SOCIETE';
export const SET_INFORMATIONS_SOCIETES = 'SET_INFORMATIONS_SOCIETES';
export const SET_INFORMATIONS_AGENCES = 'SET_INFORMATIONS_AGENCES';
export const SET_TOTAL_SOCIETES = 'SET_TOTAL_SOCIETES';
export const SET_SOCIETE_COURANTE = 'SET_SOCIETE_COURANTE';
export const SET_LOCK_MENU = 'SET_LOCK_MENU';
export const SET_FORCE_UNLOCK_MENU = 'SET_FORCE_UNLOCK_MENU';
export const SET_LOGO_AGENCES = 'SET_LOGO_AGENCES';
